var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page",class:{ 'dark-theme': _vm.isDarkMode },style:({
    backgroundColor:
      _vm.isDarkMode && _vm.isHomePage ? '#0F0F0F' : 'rgba(240, 240, 240, 1)',
  })},[(_vm.isDarkMode)?_c('div',{ref:"blobsContainer",staticClass:"background-blobs"}):_vm._e(),_c('header',{staticClass:"section page-header",class:{
      'show-button': _vm.isHomePage && _vm.showBtnHeader && _vm.btnHeaderHasUrl,
      'not-show-button': !_vm.isHomePage || !_vm.showBtnHeader || !_vm.btnHeaderHasUrl,
    }},[_c('CzMenu',{attrs:{"showBtnHeader":_vm.showBtnHeader},on:{"btn-header-has-url":_vm.onBtnHeaderHasUrl}})],1),_c('transition',{attrs:{"name":"route-fade","mode":"out-in","appear":""}},[_c('div',{key:_vm.$route.fullPath,staticClass:"margin-mobile"},[_vm._t("default")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }